import styled from "styled-components";
import { constants } from "constants";
import { HashLink } from "components/hashLink";
import { Bits } from "components/bits";
import { Essence } from "components/essence";

const StyledHero = styled.section`
  min-height: calc(100vh - ${constants.headerHeight}px);
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(260px, 0.42fr);
  align-items: center;
  gap: clamp(40px, 8vw, 140px);
  padding: clamp(70px, 10vw, 150px) 0;

  @media (max-width: 850px) {
    min-height: auto;
    grid-template-columns: 1fr;
    gap: 48px;
    padding: 90px 0 70px;
  }
`;

const StyledIntro = styled.div`
  position: relative;
`;

const StyledEyebrow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 26px;
  font-family: Roboto-Regular;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
  color: #aeb9c1;
  text-transform: uppercase;

  &::before {
    content: "";
    width: 38px;
    height: 2px;
    background: ${constants.colors.orange};
  }
`;

const StyledTitle = styled.h1`
  max-width: 900px;
  margin: 0;
  font-family: Roboto-Black;
  font-size: clamp(58px, 8.4vw, 132px);
  line-height: 0.88;
  letter-spacing: -0.075em;
  color: ${constants.colors.bit};
  text-transform: uppercase;

  span { display: block; color: ${constants.colors.essence}; }

  @media (max-width: 360px) {
    font-size: 48px;
    line-height: 0.98;
  }
`;

const StyledSide = styled.aside`
  align-self: end;
  padding: 30px 0 16px 28px;
  border-left: 1px solid rgba(220, 226, 230, 0.18);
`;

const StyledStatement = styled.p`
  margin: 0 0 28px;
  font-family: Roboto-Light;
  font-size: clamp(18px, 1.7vw, 25px);
  line-height: 1.55;
  color: #b8c1c7;

  strong { font-family: Roboto-Black; color: #f0ece5; }
`;

const StyledActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const StyledAction = styled(HashLink)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 0 22px;
  border: 1px solid #dce2e6;
  border-radius: 999px;
  font-family: Roboto-Regular;
  font-size: 13px;
  letter-spacing: .08em;
  color: #f0ece5;
  text-transform: uppercase;
  cursor: pointer;

  &:first-child { border-color: ${constants.colors.orange}; background: ${constants.colors.orange}; color: #101923; }
  &:hover { transform: translateY(-2px); background: ${constants.colors.bit}; border-color: ${constants.colors.bit}; color: #ffffff; }
`;

export const Motto = () => (
  <StyledHero aria-labelledby="hero-title">
    <StyledIntro>
      <StyledEyebrow>Independent software studio · Moldova</StyledEyebrow>
      <StyledTitle id="hero-title">Digital craft.<span>Human care.</span></StyledTitle>
    </StyledIntro>
    <StyledSide>
      <StyledStatement>
        We bring <strong><Essence /></strong> through <strong><Bits /></strong> — building fast,
        thoughtful web and mobile products that help businesses flourish.
      </StyledStatement>
      <StyledActions>
        <StyledAction id="contacts" text="Start a project" offset={-constants.headerHeight} />
        <StyledAction id="our-services" text="Explore services" offset={-constants.headerHeight} />
      </StyledActions>
    </StyledSide>
  </StyledHero>
);
